import type {
  ArtboardPayload,
  Client,
  Invoice,
  Organization,
} from '@repo/api-client';

/**
 * Constructs the {@link ArtboardPayload} the artboard SPA expects.
 *
 * Mirrors `apps/mobile/features/preview/buildArtboardPayload.ts` so
 * the desktop and mobile previews render the exact same payload.
 *
 * What this does NOT do:
 *   - No transforms. The wire shapes already match the artboard's
 *     types byte-for-byte (server's `serializeInvoice` + `toJsonSafe`
 *     handle BigInt / Date conversion before the data hits the wire).
 *   - No defaulting `templateId`. `undefined` flows through and the
 *     artboard's `resolveTemplate` falls back to `DEFAULT_TEMPLATE_ID`.
 */
export function buildArtboardPayload(input: {
  invoice: Invoice;
  organization: Organization;
  client: Client | null;
  templateId?: string;
}): ArtboardPayload {
  const { invoice, organization, client, templateId } = input;
  const payload: ArtboardPayload = {
    invoice,
    organization,
    client,
  };
  if (templateId) {
    payload.templateId = templateId;
  }
  return payload;
}
